export default __webpack_public_path__ + "static/media/banner_review.9f687b1d.jpg";